<template>
  <main v-editable="props.blok" class="page" :data-uid="props.blok._uid">
    <StoryblokComponent
      v-for="contentBlok in props.blok.ContentBlocks"
      :id="contentBlok._uid"
      :key="contentBlok._uid"
      :blok="contentBlok"
    />
  </main>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  urlPath: {
    type: String,
    required: false,
    default: '',
  },
})

const url = useRequestURL()
const tracking = useTracking()
const publicConfig = useRuntimeConfig().public
const productName = props.urlPath.split('/')[0]
// don't use ?? for this as that only checks on null and undefined, but we also have to use the fallback if it is an empty string
const headTitle = props.blok.seo?.title ? props.blok.seo.title : props.blok.title
const getMetaRobotContent = (robots) => {
  if (typeof robots !== 'object') {
    return { all: true }
  }
  return robots.reduce((resultObject, currentValue) => {
    resultObject[currentValue] = true
    return resultObject
  }, {})
}

if (props.blok.seo) {
  useSeoMeta({
    title: headTitle,
    applicationName: headTitle,
    description: props.blok.seo.description,
    ogUrl: `${url.origin}${url.pathname}`,
    ogTitle: props.blok.seo.og_title === '' ? headTitle : props.blok.seo.og_title,
    ogDescription:
      props.blok.seo.og_description === ''
        ? props.blok.seo.description
        : props.blok.seo.og_description,
    twitterTitle: props.blok.seo.twitter_title === '' ? headTitle : props.blok.seo.twitter_title,
    twitterDescription:
      props.blok.seo.twitter_description === ''
        ? props.blok.seo.description
        : props.blok.seo.twitter_description,
    twitterImage: props.blok.seo.twitter_image,
    robots: getMetaRobotContent(props.blok.seoRobots),
    ogType: 'website',
    ogImage: props.blok.seo.og_image,
    twitterCard: 'summary_large_image',
    twitterSite: '@pflegede',
  })

  useHead({
    style: [{ textContent: props.blok.css }],
  })
}

onBeforeMount(async () => {
  tracking.init(publicConfig.googleTagmanagerKey, {
    pageTitle: headTitle,
  })
  tracking.trackDatalayer({ event: 'page_view', label: props.urlPath })
  void tracking.initET(productName) // Don't delay initialization of the component for ET.
})
</script>
